import { projectApi } from '@highlight-cp/project-api';

import { useGetCurrentProjectId } from '../use-get-current-project-id';

const useGetAudience = () => {
  const projectId = useGetCurrentProjectId();
  return projectApi.useGetProjectsByProjectIdAudienceBuilderAudienceQuery(
    { projectId: projectId ?? -1 },
    { skip: !projectId },
  );
};

export default useGetAudience;
